"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const InactiveCircleIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      transform: "translate(-444 -667)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M455.771,669 C453.16,669 450.705,670.017 448.859,671.862 C445.046,675.674 445.046,681.877 448.857,685.69 C450.703,687.536 453.158,688.552 455.769,688.552 C458.382,688.552 460.837,687.535 462.685,685.688 C466.496,681.876 466.496,675.674 462.683,671.862 C460.837,670.017 458.382,669 455.771,669 M455.769,690.552 C452.623,690.552 449.666,689.328 447.443,687.104 C442.851,682.512 442.853,675.04 447.445,670.448 C449.669,668.225 452.626,667 455.771,667 C458.917,667 461.875,668.225 464.097,670.448 C468.689,675.039 468.689,682.51 464.099,687.103 C461.875,689.327 458.916,690.552 455.769,690.552",
        fill: color
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M450,679.208333 L462,679.208333",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round"
      })]
    })
  })]
});

InactiveCircleIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = InactiveCircleIcon;
exports.default = _default;